import React, { useState } from 'react';
import { Card, Input, Button, Row, Col, message } from 'antd';
import { CryptoUtil } from '@/utils/crypto';

const { TextArea } = Input;

const CryptoPage: React.FC = () => {
  const [inputText, setInputText] = useState('');
  const [outputText, setOutputText] = useState('');

  const handleEncrypt = () => {
    if (!inputText) {
      message.warning('请输入需要加密的内容');
      return;
    }
    try {
      const encrypted = CryptoUtil.encrypt(inputText);
      setOutputText(encrypted);
    } catch (error) {
      message.error('加密失败');
    }
  };

  const handleDecrypt = () => {
    if (!inputText) {
      message.warning('请输入需要解密的内容');
      return;
    }
    try {
      const decrypted = CryptoUtil.decrypt(inputText);
      setOutputText(decrypted);
    } catch (error) {
      message.error('解密失败');
    }
  };

  return (
    <Card title="加解密工具" bordered={false}>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <TextArea
            rows={4}
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
            placeholder="请输入需要加密/解密的内容"
          />
        </Col>
        <Col span={24}>
          <Button type="primary" onClick={handleEncrypt} style={{ marginRight: 8 }}>
            加密
          </Button>
          <Button onClick={handleDecrypt}>解密</Button>
        </Col>
        <Col span={24}>
          <TextArea
            rows={4}
            value={outputText}
            readOnly
            placeholder="加密/解密结果"
          />
        </Col>
      </Row>
    </Card>
  );
};

export default CryptoPage;
